import type { ChangeEvent } from 'react'
import { useCallback } from 'react'
import { SwitchBase } from '@instacart/ids-tooling'
import { Accordion, Text } from '@retailer-platform/shared-components'
import { useDashMessages } from '../../../../intl/intl.hooks'
import { useAiAgent } from '../../../../utils/contexts/ai/AiAgentContext'

export const AiAgentEnabled = () => {
  let enabled: boolean
  let setEnabled: (enabled: boolean) => void

  try {
    const aiAgent = useAiAgent()
    enabled = aiAgent.isAgentUserEnabled
    setEnabled = aiAgent.setEnabled
  } catch (error) {
    // If AiAgent context is not available, default to enabled and no-op setter
    console.warn('AiAgent context not available in AiAgentEnabled control')
    enabled = true
    setEnabled = () => {}
  }

  const handleSwitchChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setEnabled(event.target.checked)
    },
    [setEnabled]
  )

  const i18n = useDashMessages({
    aiAgentEnabledTitle: 'app.admin.controlPanel.setting.aiAgentEnabled.title',
    aiAgentEnabledDesc: 'app.admin.controlPanel.setting.aiAgentEnabled.description',
  })

  const title = (
    <div css={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
      {i18n.aiAgentEnabledTitle}

      <div css={{ flex: 1 }} />

      <div css={{ overflow: 'hidden' }}>
        <SwitchBase
          name="aiAgentEnabledSwitch"
          id="aiAgentEnabledSwitch"
          checked={enabled}
          onClick={evt => evt.stopPropagation()}
          onChange={handleSwitchChange}
        />
      </div>
    </div>
  )

  return (
    <Accordion showContentBackground={true} title={title}>
      <Text size="small">{i18n.aiAgentEnabledDesc}</Text>
    </Accordion>
  )
}
